/* Native dialog supplies the focus trap, inert background and Escape key.
   One delegated listener survives Shopify section reloads and cart updates. */
(() => {
  if (window.MoodiGiftOffer) return;
  window.MoodiGiftOffer = true;

  const active = new Map();
  const release = (dialog) => {
    const state = active.get(dialog);
    active.delete(dialog);
    if (!active.size) document.body.classList.remove('moodi-gift-offer-open');
    if (state?.trigger.isConnected) state.trigger.focus({ preventScroll: true });
    if (state) window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mcb-offer-trigger]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
      const state = { trigger, x: window.scrollX, y: window.scrollY };
      active.set(dialog, state);
      document.body.classList.add('moodi-gift-offer-open');
      dialog.addEventListener('close', () => release(dialog), { once: true });
      dialog.showModal();
      // Native autofocus can scroll an ancestor when the dialog is inside a
      // sticky section. Keep the browsing position captured before opening.
      window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
      return;
    }
    const close = event.target.closest('[data-mcb-offer-close]');
    if (close) close.closest('dialog[data-mcb-offer-dialog]')?.close();
    const dialog = event.target;
    if (dialog.matches?.('dialog[data-mcb-offer-dialog][open]')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('dialog[data-mcb-offer-dialog]').forEach((dialog) => {
      if (dialog.open) dialog.close();
      // Section removal can race the native close event; cleanup is idempotent.
      if (active.has(dialog)) release(dialog);
    });
  });
})();
